<section
  class="profile-menu"
  role="navigation"
  [attr.aria-label]="'global.account' | translate">
  <div class="profile-menu__header">
    <div class="header-user">
      <img
        [ngSrc]="
          user?.profile_image?.cropped_url?.toLowerCase() ||
            user?.profile_image?.url
            | imageSource: false : 'sm' : 'assets/images/no-profile-image.png'
        "
        width="56"
        height="56"
        alt=""
        class="header-user__img" />
      <div class="header-user__info">
        <h4 class="info-name" [attr.title]="user?.username || null">
          {{ user?.username || '' }}
        </h4>

        @if (user?.job_position) {
          <p class="info-role">
            {{ user.job_position | translateData }}
          </p>
        }
      </div>
    </div>
    <button
      type="button"
      class="profile-menu__logout"
      (click)="logout()"
      [attr.aria-label]="'global.logout' | translate">
      <i class="profile-menu__logout-icon iconsax" icon-name="logout-2"></i>
    </button>
  </div>

  <ul class="profile-menu__list">
    @for (item of menuInternalRoutes; track $index) {
      <li class="profile-menu__item" (click)="onClickProfileMenuItems()">
        <a
          class="profile-menu__link"
          [routerLink]="item.route"
          [attr.aria-current]="
            item.route && currentRoute?.includes(item.route)
              ? 'page'
              : null
          "
          [class.profile-menu__link--active]="
            item.route && currentRoute?.includes(item.route)
          ">
          <i class="profile-menu__icon iconsax" [attr.icon-name]="item.icon"></i>
          <span class="profile-menu__label">{{ item.name | translate }}</span>
        </a>
      </li>
    }

    <li class="profile-menu__section" role="presentation">
      <span class="profile-menu__section-title" id="profile-menu-panel-heading">
        {{ 'global.panel' | translate }}
      </span>
    </li>

    @for (item of menuExternalRoutes; track $index) {
      <li class="profile-menu__item" (click)="onClickProfileMenuItems()">
        <a class="profile-menu__link" [href]="item.href">
          <i class="profile-menu__icon iconsax" [attr.icon-name]="item.icon"></i>
          <span class="profile-menu__label">{{ item.name | translate }}</span>
        </a>
      </li>
    }
  </ul>
</section>
